module.exports = __webpack_public_path__ + "img/qat.b314986b.svg";